import { render, staticRenderFns } from "./FinanceWidget.vue?vue&type=template&id=f6d7015a&scoped=true"
import script from "./FinanceWidget.vue?vue&type=script&lang=js"
export * from "./FinanceWidget.vue?vue&type=script&lang=js"
import style0 from "./FinanceWidget.vue?vue&type=style&index=0&id=f6d7015a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d7015a",
  null
  
)

export default component.exports